export const ROUTES = {
  languexSignIn: "https://app.languex.co/auth/sign-in",
  startOrder: "/order",
  getQuote: "/get-quote",
  standardTranslation: "/translations",
  certifiedTranslation: "/certified-translation",
  enterpriseTranslation: "/business-translation",
  documentsAndDeliverables: "/documents"
} as const;
